import useActiveOrdersSessionsQuery from "../queries/orderssessions/useActiveOrdersSessionsQuery";
import { asArray } from "../utils/helpers";

const useTableSessionHook = (table: number) => {
  const query = useActiveOrdersSessionsQuery();
  const session = query?.data?.find(
    (s) =>
      asArray(s.current_table_ids)?.includes(table) &&
      s.session_status !== 5 &&
      !s.is_removed
  );
  return { ...query, session };
};

export default useTableSessionHook;
